
import React from 'react';

import { Calendar } from "@progress/kendo-react-dateinputs";

export const DecadeCalendar = (props: any) => {

    return (
        <Calendar
            {...props}
            bottomView="decade"
            topView="decade"
            value={props.value}
            onChange={props.onChange}
        />
    );

}
export const YearCalendar = (props: any) => {

    return (
        <Calendar
            {...props}
            bottomView="year"
            topView="year"
            value={props.value}
            onChange={props.onChange}
        />
    );

}